/* Built In Imports */

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
import MidContainer from '@Layout/MidContainer';
import SectionTitle from '@components/Headings/SectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Services */

/**
 *
 * @param {Object} section
 * @returns
 */
const ContactUs = ({ section, region, lang, cityId }) => {
  const sectionContent = section?.sectionContent;

  return (
    <Box pb={{ base: '25px', md: '40px' }} pt="20px" bgColor="#F1EBDF">
      <SectionTitle
        titleObj={{
          title: sectionContent[0]?.titleText,
          titleDecoration: 'flowers',
          titleSubtext: sectionContent[0]?.titleSubtext,
        }}
        mt="0"
        w={{ base: '100%', sm: '365px' }}
        lineHeight="35px"
        color="#02026C"
      />
      <MidContainer w={'680'}>
        <Flex
          flexDir={{ base: 'column', lg: 'row' }}
          mb="30px"
          justifyContent={{ base: 'center' }}
        >
          <Box
            mr={{ base: '0', md: '70px' }}
            pt={{ base: '20px', lg: '1%' }}
            pb="30px"
            m={{ base: '0 16px', lg: '0' }}
            // className="event-text"
            color="#fff"
          >
            <StructuredTextParser
              str={render(sectionContent[1]?.body)}
              color="#000"
              mt="0"
              fontSize={{ base: '18px', md: '20px' }}
              lineHeight={{ base: '30px', md: '34px' }}
              fontFamily="FedraSansStd-book"
              fontWeight="400"
              className="eoeCU"
              textAlign="center"
            />
            <style global jsx>
              {`
                .eoeCU p a,
                .eoeCU a {
                  color: #c4321f;
                  text-decoration: underline;
                }
              `}
            </style>
          </Box>
        </Flex>
      </MidContainer>
    </Box>
  );
};

export default ContactUs;
